/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type {
    DeviceAndConnectorStatus,
    FaultGuruRecommendationResponse,
    LogMessageOutputModel,
    OnlineStatusItem,
    OnlineStatusPercentageDto,
    SimpleDeviceStatusPercentageDto,
    StatusItem,
} from "../models/index";
import {
    DeviceAndConnectorStatusFromJSON,
    DeviceAndConnectorStatusToJSON,
    FaultGuruRecommendationResponseFromJSON,
    FaultGuruRecommendationResponseToJSON,
    LogMessageOutputModelFromJSON,
    LogMessageOutputModelToJSON,
    OnlineStatusItemFromJSON,
    OnlineStatusItemToJSON,
    OnlineStatusPercentageDtoFromJSON,
    OnlineStatusPercentageDtoToJSON,
    SimpleDeviceStatusPercentageDtoFromJSON,
    SimpleDeviceStatusPercentageDtoToJSON,
    StatusItemFromJSON,
    StatusItemToJSON,
} from "../models/index";

export interface GetDeviceAndConnectorStatusesODataRequest {
    deviceIdentity: string;
}

export interface GetDeviceFaultRecommendationRequest {
    deviceIdentity: string;
    statusItemId: number;
}

export interface GetDeviceLogMessagesRequest {
    deviceIdentity: string;
}

export interface GetOnlineStatusPercentageRequest {
    from: string;
    to: string;
    deviceIdentity: string;
    interval: GetOnlineStatusPercentageIntervalEnum;
}

export interface GetSimpleDeviceStatusPercentageRequest {
    from: string;
    to: string;
    deviceIdentity: string;
    interval: GetSimpleDeviceStatusPercentageIntervalEnum;
    connectorIndex?: number;
}

export interface OnlineStatusLogsODataRequest {
    deviceIdentity: string;
}

export interface StatusLogsODataRequest {
    deviceIdentity: string;
}

/**
 *
 */
export class LogMessagesHttpFunctionsApi extends runtime.BaseAPI {
    /**
     * OData query on DeviceAndConnectorStatuses, which represents device online/offline statuses and connector statuses
     */
    async getDeviceAndConnectorStatusesODataRaw(
        requestParameters: GetDeviceAndConnectorStatusesODataRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<Array<DeviceAndConnectorStatus>>> {
        if (requestParameters["deviceIdentity"] == null) {
            throw new runtime.RequiredError(
                "deviceIdentity",
                'Required parameter "deviceIdentity" was null or undefined when calling getDeviceAndConnectorStatusesOData().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/devices/{deviceIdentity}/device-and-connector-statuses`.replace(
                    `{${"deviceIdentity"}}`,
                    encodeURIComponent(
                        String(requestParameters["deviceIdentity"]),
                    ),
                ),
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            jsonValue.map(DeviceAndConnectorStatusFromJSON),
        );
    }

    /**
     * OData query on DeviceAndConnectorStatuses, which represents device online/offline statuses and connector statuses
     */
    async getDeviceAndConnectorStatusesOData(
        requestParameters: GetDeviceAndConnectorStatusesODataRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<Array<DeviceAndConnectorStatus>> {
        const response = await this.getDeviceAndConnectorStatusesODataRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Returns recommendation for device fault
     */
    async getDeviceFaultRecommendationRaw(
        requestParameters: GetDeviceFaultRecommendationRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<FaultGuruRecommendationResponse>> {
        if (requestParameters["deviceIdentity"] == null) {
            throw new runtime.RequiredError(
                "deviceIdentity",
                'Required parameter "deviceIdentity" was null or undefined when calling getDeviceFaultRecommendation().',
            );
        }

        if (requestParameters["statusItemId"] == null) {
            throw new runtime.RequiredError(
                "statusItemId",
                'Required parameter "statusItemId" was null or undefined when calling getDeviceFaultRecommendation().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/devices/{deviceIdentity}/status-logs/faulted/{statusItemId}/recommendation`
                    .replace(
                        `{${"deviceIdentity"}}`,
                        encodeURIComponent(
                            String(requestParameters["deviceIdentity"]),
                        ),
                    )
                    .replace(
                        `{${"statusItemId"}}`,
                        encodeURIComponent(
                            String(requestParameters["statusItemId"]),
                        ),
                    ),
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            FaultGuruRecommendationResponseFromJSON(jsonValue),
        );
    }

    /**
     * Returns recommendation for device fault
     */
    async getDeviceFaultRecommendation(
        requestParameters: GetDeviceFaultRecommendationRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<FaultGuruRecommendationResponse> {
        const response = await this.getDeviceFaultRecommendationRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Get the device log messages.
     */
    async getDeviceLogMessagesRaw(
        requestParameters: GetDeviceLogMessagesRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<Array<LogMessageOutputModel>>> {
        if (requestParameters["deviceIdentity"] == null) {
            throw new runtime.RequiredError(
                "deviceIdentity",
                'Required parameter "deviceIdentity" was null or undefined when calling getDeviceLogMessages().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/devices/{deviceIdentity}/log-messages-odata`.replace(
                    `{${"deviceIdentity"}}`,
                    encodeURIComponent(
                        String(requestParameters["deviceIdentity"]),
                    ),
                ),
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            jsonValue.map(LogMessageOutputModelFromJSON),
        );
    }

    /**
     * Get the device log messages.
     */
    async getDeviceLogMessages(
        requestParameters: GetDeviceLogMessagesRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<Array<LogMessageOutputModel>> {
        const response = await this.getDeviceLogMessagesRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Get daily online and offline percentages based on status logs, infer status percentages for days without logs from previous log regardless of date.
     */
    async getOnlineStatusPercentageRaw(
        requestParameters: GetOnlineStatusPercentageRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<Array<OnlineStatusPercentageDto>>> {
        if (requestParameters["from"] == null) {
            throw new runtime.RequiredError(
                "from",
                'Required parameter "from" was null or undefined when calling getOnlineStatusPercentage().',
            );
        }

        if (requestParameters["to"] == null) {
            throw new runtime.RequiredError(
                "to",
                'Required parameter "to" was null or undefined when calling getOnlineStatusPercentage().',
            );
        }

        if (requestParameters["deviceIdentity"] == null) {
            throw new runtime.RequiredError(
                "deviceIdentity",
                'Required parameter "deviceIdentity" was null or undefined when calling getOnlineStatusPercentage().',
            );
        }

        if (requestParameters["interval"] == null) {
            throw new runtime.RequiredError(
                "interval",
                'Required parameter "interval" was null or undefined when calling getOnlineStatusPercentage().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters["from"] != null) {
            queryParameters["from"] = requestParameters["from"];
        }

        if (requestParameters["to"] != null) {
            queryParameters["to"] = requestParameters["to"];
        }

        if (requestParameters["interval"] != null) {
            queryParameters["interval"] = requestParameters["interval"];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/devices/{deviceIdentity}/online-status-percentage`.replace(
                    `{${"deviceIdentity"}}`,
                    encodeURIComponent(
                        String(requestParameters["deviceIdentity"]),
                    ),
                ),
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            jsonValue.map(OnlineStatusPercentageDtoFromJSON),
        );
    }

    /**
     * Get daily online and offline percentages based on status logs, infer status percentages for days without logs from previous log regardless of date.
     */
    async getOnlineStatusPercentage(
        requestParameters: GetOnlineStatusPercentageRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<Array<OnlineStatusPercentageDto>> {
        const response = await this.getOnlineStatusPercentageRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Get daily simple device status percentages based on status logs. Calculations are based on local device time.
     */
    async getSimpleDeviceStatusPercentageRaw(
        requestParameters: GetSimpleDeviceStatusPercentageRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<Array<SimpleDeviceStatusPercentageDto>>> {
        if (requestParameters["from"] == null) {
            throw new runtime.RequiredError(
                "from",
                'Required parameter "from" was null or undefined when calling getSimpleDeviceStatusPercentage().',
            );
        }

        if (requestParameters["to"] == null) {
            throw new runtime.RequiredError(
                "to",
                'Required parameter "to" was null or undefined when calling getSimpleDeviceStatusPercentage().',
            );
        }

        if (requestParameters["deviceIdentity"] == null) {
            throw new runtime.RequiredError(
                "deviceIdentity",
                'Required parameter "deviceIdentity" was null or undefined when calling getSimpleDeviceStatusPercentage().',
            );
        }

        if (requestParameters["interval"] == null) {
            throw new runtime.RequiredError(
                "interval",
                'Required parameter "interval" was null or undefined when calling getSimpleDeviceStatusPercentage().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters["from"] != null) {
            queryParameters["from"] = requestParameters["from"];
        }

        if (requestParameters["to"] != null) {
            queryParameters["to"] = requestParameters["to"];
        }

        if (requestParameters["interval"] != null) {
            queryParameters["interval"] = requestParameters["interval"];
        }

        if (requestParameters["connectorIndex"] != null) {
            queryParameters["connectorIndex"] =
                requestParameters["connectorIndex"];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/devices/{deviceIdentity}/simple-device-status-percentage`.replace(
                    `{${"deviceIdentity"}}`,
                    encodeURIComponent(
                        String(requestParameters["deviceIdentity"]),
                    ),
                ),
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            jsonValue.map(SimpleDeviceStatusPercentageDtoFromJSON),
        );
    }

    /**
     * Get daily simple device status percentages based on status logs. Calculations are based on local device time.
     */
    async getSimpleDeviceStatusPercentage(
        requestParameters: GetSimpleDeviceStatusPercentageRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<Array<SimpleDeviceStatusPercentageDto>> {
        const response = await this.getSimpleDeviceStatusPercentageRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * OData query on OnlineStatusItems, which logs online state of a device
     */
    async onlineStatusLogsODataRaw(
        requestParameters: OnlineStatusLogsODataRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<Array<OnlineStatusItem>>> {
        if (requestParameters["deviceIdentity"] == null) {
            throw new runtime.RequiredError(
                "deviceIdentity",
                'Required parameter "deviceIdentity" was null or undefined when calling onlineStatusLogsOData().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/devices/{deviceIdentity}/online-status-logs-odata`.replace(
                    `{${"deviceIdentity"}}`,
                    encodeURIComponent(
                        String(requestParameters["deviceIdentity"]),
                    ),
                ),
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            jsonValue.map(OnlineStatusItemFromJSON),
        );
    }

    /**
     * OData query on OnlineStatusItems, which logs online state of a device
     */
    async onlineStatusLogsOData(
        requestParameters: OnlineStatusLogsODataRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<Array<OnlineStatusItem>> {
        const response = await this.onlineStatusLogsODataRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * OData query on StatusItems, which logs device and connector status updates
     */
    async statusLogsODataRaw(
        requestParameters: StatusLogsODataRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<Array<StatusItem>>> {
        if (requestParameters["deviceIdentity"] == null) {
            throw new runtime.RequiredError(
                "deviceIdentity",
                'Required parameter "deviceIdentity" was null or undefined when calling statusLogsOData().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/devices/{deviceIdentity}/status-logs-odata`.replace(
                    `{${"deviceIdentity"}}`,
                    encodeURIComponent(
                        String(requestParameters["deviceIdentity"]),
                    ),
                ),
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            jsonValue.map(StatusItemFromJSON),
        );
    }

    /**
     * OData query on StatusItems, which logs device and connector status updates
     */
    async statusLogsOData(
        requestParameters: StatusLogsODataRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<Array<StatusItem>> {
        const response = await this.statusLogsODataRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }
}

/**
 * @export
 */
export const GetOnlineStatusPercentageIntervalEnum = {
    TenMinutes: "tenMinutes",
    ThirtyMinutes: "thirtyMinutes",
    Hour: "hour",
    TwelveHours: "twelveHours",
    Day: "day",
} as const;
export type GetOnlineStatusPercentageIntervalEnum =
    (typeof GetOnlineStatusPercentageIntervalEnum)[keyof typeof GetOnlineStatusPercentageIntervalEnum];
/**
 * @export
 */
export const GetSimpleDeviceStatusPercentageIntervalEnum = {
    TenMinutes: "tenMinutes",
    ThirtyMinutes: "thirtyMinutes",
    Hour: "hour",
    TwelveHours: "twelveHours",
    Day: "day",
} as const;
export type GetSimpleDeviceStatusPercentageIntervalEnum =
    (typeof GetSimpleDeviceStatusPercentageIntervalEnum)[keyof typeof GetSimpleDeviceStatusPercentageIntervalEnum];
